import config from "../config/app.conf.json";

export default (entityId, uid) => {
  return {
    url: `${config.api.organizations_url}/organizations/${entityId}/users/${uid}`,
    method: "DELETE"
  };
};
